module.exports = __webpack_public_path__ + "img/close-popup.fb537036.svg";